<template>
  <el-dialog
    title="新增供应商"
    :visible.sync="dialogVisible"
    width="50%"
    >
    <el-form :model="supplierFrom" ref="ruleForm" :rules="rules" label-width="100px">
      <el-form-item label="供应商名称：" prop="name">
        <el-input v-model="supplierFrom.name"></el-input>
      </el-form-item>
      <el-form-item label="联系人：" prop="contactName">
        <el-input v-model="supplierFrom.contactName"></el-input>
      </el-form-item>
      <el-form-item label="手机号码：" prop="mobile">
        <el-input v-model="supplierFrom.mobile"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button @click="saveContinue">保存并继续添加</el-button>
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { prodSupplierAdd } from '@/servers/prod/center/index.js'
export default {
  data() {
    return {
      dialogVisible: false,
      supplierFrom: {
        name: '',
        contactName: '',
        mobile: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' },
        ],
        mobile: [
          { pattern: /^[0-9]*$/, message: '手机号必须是数字', trigger: 'blur' },
          { len: 11, message: '手机号必须是11位', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    method_open() {
      this.dialogVisible = true;
    },
    handleCancel() {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    handleSave() {
      this.$refs.ruleForm.validate(async valid => {
        if(!valid) return;
        const res = await prodSupplierAdd(this.supplierFrom);
        if(!res) return;
        this.$message.success('新增成功');
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
        this.$emit('search')
      })
    },
    saveContinue() {
      this.$refs.ruleForm.validate(async valid => {
        if(!valid) return;
        const res = await prodSupplierAdd(this.supplierFrom);
        if(!res) return;
        this.$message.success('新增成功');
        this.$refs.ruleForm.resetFields();
        this.$emit('search')
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>